import { Controller } from "@hotwired/stimulus"

// Naseptavac v horni liste: objednavky a produkty. Enter bez vyberu odesle formular (hledani objednavek) jako dosud.
export default class extends Controller {
  static targets = ["input", "menu"]
  static values  = { url: String, scope: String, ordersLabel: String, productsLabel: String, emptyLabel: String }

  connect() {
    this.timer = null
    this.active = -1
    this.onDocumentClick = (e) => { if (!this.element.contains(e.target)) this.hide() }
    document.addEventListener("click", this.onDocumentClick)
    // klik do seznamu nesmi vzit inputu fokus - jinak by formular se submit_on_change odeslal filtr misto otevreni detailu
    this.menuTarget.addEventListener("mousedown", (e) => e.preventDefault())
    this.menuTarget.addEventListener("click", () => this.resetInput())
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    clearTimeout(this.timer)
  }

  search() {
    clearTimeout(this.timer)
    const q = this.inputTarget.value.trim()
    if (q.length < 3) return this.hide()
    this.timer = setTimeout(() => this.fetch(q), 250)
  }

  fetch(q) {
    this.lastQuery = q
    const scope = this.scopeValue ? `&scope=${encodeURIComponent(this.scopeValue)}` : ""
    fetch(`${this.urlValue}?q=${encodeURIComponent(q)}${scope}`, { headers: { "Accept": "application/json" } })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data && q === this.lastQuery) this.render(data) })
  }

  render(data) {
    const menu = this.menuTarget
    menu.innerHTML = ""
    this.active = -1
    const addGroup = (title, items) => {
      if (!items.length) return
      if (title) {
        const h = document.createElement("h6")
        h.className = "dropdown-header"
        h.textContent = title
        menu.appendChild(h)
      }
      items.forEach(item => {
        const a = document.createElement("a")
        a.className = "dropdown-item global-search-item"
        a.href = item.url
        const label = document.createElement("div")
        label.textContent = item.label
        const sub = document.createElement("small")
        sub.className = "text-muted"
        sub.textContent = item.sub
        a.append(label, sub)
        menu.appendChild(a)
      })
    }
    const showHeaders = !this.scopeValue
    addGroup(showHeaders ? this.ordersLabelValue : null, data.orders)
    addGroup(showHeaders ? this.productsLabelValue : null, data.products)
    if (!data.orders.length && !data.products.length) {
      const empty = document.createElement("span")
      empty.className = "dropdown-item-text text-muted"
      empty.textContent = this.emptyLabelValue
      menu.appendChild(empty)
    }
    menu.classList.add("show")
  }

  keydown(event) {
    const items = Array.from(this.menuTarget.querySelectorAll(".global-search-item"))
    if (event.key === "Escape") return this.hide()
    if (!items.length || !this.menuTarget.classList.contains("show")) return
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      this.active = (this.active + (event.key === "ArrowDown" ? 1 : -1) + items.length) % items.length
      items.forEach((el, i) => el.classList.toggle("active", i === this.active))
    } else if (event.key === "Enter" && this.active >= 0) {
      event.preventDefault()
      this.resetInput()
      window.location.href = items[this.active].href
    }
  }

  // vratit puvodni hodnotu, aby blur pri odchodu ze stranky nevyvolal change (submit_on_change)
  resetInput() {
    this.inputTarget.value = this.inputTarget.defaultValue
  }

  hide() {
    this.menuTarget.classList.remove("show")
    this.active = -1
  }
}
